import {
  DialogPositioningBehavior,
  DialogType,
  DialogWidget,
  HorizontalOriginOption, OriginOptions, TabStyles, VerticalOriginOption
} from '@tableau/widgets';
import * as React from 'react';
import { Hover } from '../Components/Hover';

export type TooltipDelayType = number | 'none';

export interface TooltipAnchorProps {
  readonly tooltipContent: React.ComponentType<{}>;
  readonly width: number;
  readonly title: string;
  readonly onShowTooltip?: () => void;
  readonly delay?: number;
  readonly disableAutoFocus?: boolean; // for cases when there is no focusable content in the tooltip
  readonly anchorOrigin?: OriginOptions;
}

export interface TooltipAnchorState {
  readonly showingTooltip: boolean;
}

const DefaultAnchorOrigin: OriginOptions = {
  horizontal: HorizontalOriginOption.right,
  vertical: VerticalOriginOption.centerY
};

export class TooltipAnchor extends React.PureComponent<TooltipAnchorProps, TooltipAnchorState> {
  private anchorElement: HTMLElement;
  private isMouseOverTooltipTarget = false;

  constructor(props: TooltipAnchorProps) {
    super(props);
    this.state = { showingTooltip: false };
  }

  public render() {
    return (
      <div ref={this.setAnchorElementRef}>
        <Hover groupName="content-tooltip"
              enterDelay={this.props.delay >= 0 ? this.props.delay : 100}
              onEnter={this.showTooltip}
              onLeave={this.hideTooltip}
              leaveOnScroll={true}>
          { this.state.showingTooltip && this.renderTooltip() }
          { this.props.children }
        </Hover>
      </div>
    );
  }

  private renderTooltip() {
    const TooltipContent = this.props.tooltipContent;
    const widthWithDialogPadding = this.props.width + 2 * TabStyles.Spacing.LargeSpace;

    return (
      <DialogWidget type={DialogType.Uber}
                    testId="content-info-overlay"
                    dialogWidth={widthWithDialogPadding}
                    showCloseButton={false}
                    onCloseRequest={this.hideTooltip}
                    positioningBehavior={DialogPositioningBehavior.Anchored}
                    anchorOrigin={this.props.anchorOrigin || DefaultAnchorOrigin}
                    isModal={false}
                    anchorEl={this.anchorElement}
                    showFooter={false}
                    disableAutoFocus={this.props.disableAutoFocus}
                    title={this.props.title}>
        <TooltipContent />
      </DialogWidget>
    );
  }

  public componentWillUnmount() {
    this.anchorElement = null;
  }

  private setAnchorElementRef = (element: HTMLElement) => {
    this.anchorElement = element;
  }

  private showTooltip = () => {
    this.anchorElement && this.setState({ showingTooltip: true });
    if (this.props.onShowTooltip) {
      this.props.onShowTooltip();
    }
  }

  private hideTooltip = () => {
    this.anchorElement && this.setState({ showingTooltip: false });
  }
}
